import React from 'react';

import { Button } from '@sololearnorg/sol';

import useStyles from 'isomorphic-style-loader/useStyles';

import s from './Modals.scss';
import { Container, i18n } from '../../../../symphony';
import { SlEventsService } from '../../services/Business/sl-events.service';
import { lePlaygroundContext, tiyCodeResetModalId } from '../../global-constants';
import { SlModal } from '../../../../shared/public/SlModal/SlModal';

export function ModalReset(): JSX.Element {
	useStyles(s);

	const eventService = Container.take(lePlaygroundContext.value, SlEventsService);

	return (
		<SlModal id={tiyCodeResetModalId}>
			<div className="sl-tiy-inputs-modal" onKeyDown={(e) => e.stopPropagation()}>
				<h3 className="sl-tiy-inputs-modal__title">
					{i18n.t('code.reset-bottomsheet-title')}
				</h3>
				<p className="sl-tiy-inputs-modal__sub-title">{i18n.t('code.reset-bottomsheet-subtitle')}</p>
				<Button
					className="sl-tiy-inputs-modal__reset-btn"
					onClick={eventService.onTIYEditorResetConfirm}
				>
					{i18n.t('code.reset-bottomsheet-positive-title').toLowerCase()}
				</Button>
			</div>
		</SlModal>
	);
}
